import { SET_SR_DOCUMENT_STATES, CLEAR_SR_DOCUMENT_STATES } from 'actions/types'

// Passing data back to reducers
const setSrDocumentState = (obj, type) => {
  const action = { type: type, payload: obj }
  return action
}

// Set up data
export const fetchSrDocumentStates = (srdoc) => async (dispatch) => {
  const options = [
    {
      text: 'Open',
      value: '0',
      checked: srdoc.current_state === 0 ? true : false,
    },
    {
      text: 'Completed',
      value: '1',
      checked: srdoc.current_state === 1 ? true : false,
    },
    {
      text: 'Abandoned',
      value: '2',
      checked: srdoc.current_state === 2 ? true : false,
    },
  ]

  dispatch(setSrDocumentState(options, SET_SR_DOCUMENT_STATES))
}

export const clearSrDocumentStates = () => async (dispatch) => {
  dispatch(setSrDocumentState([], CLEAR_SR_DOCUMENT_STATES))
}
